import { useConfirm } from '@/services/confirm/ConfirmationService';
import { FC } from 'react';
import { LinkProps, useLinkClickHandler } from 'react-router-dom';
import { twMerge } from 'tailwind-merge';

interface Props extends LinkProps {
  onNavigate?: () => void;
}

export const ConfirmedLink: FC<Props> = ({ className, to, replace = false, state, target, onNavigate, ...props }) => {
  const handleClick = useLinkClickHandler(to, {
    replace,
    state,
    target
  });

  const isActive = location.pathname === to.toString();

  const { requestConfirmation } = useConfirm(state => ({ requestConfirmation: state.requestConfirmation }));

  return (
    <a
      {...props}
      className={twMerge(className, 'cursor-pointer')}
      onClick={
        !isActive
          ? event => {
              requestConfirmation(() => {
                handleClick(event);
                onNavigate && onNavigate();
              });
            }
          : event => onNavigate && onNavigate()
      }
    ></a>
  );
};
